import React, { useState, useEffect } from 'react';
import ToolkitProvider, { CSVExport, Search  } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import useToken from '../../App/useToken';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import StudentService from '../../service/studentService'
import './Spc.css'
const unitSpcs = require('../../utils/UnitJson');
const units = require('../../utils/UnitJson');
const spcs = require('../../utils/SpcJson');

const { ExportCSVButton } = CSVExport;
export default function SpcDashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const { getToken, getUnitSpcNo } = useToken();
  const token = getToken();
  const unitSpcNo = getUnitSpcNo();

  const getStudentSpc = async () => {
    const studentService = new StudentService();
    const res = await studentService.getStudentByUnitSpcNo(unitSpcNo, token);
    if(res?.data) setStudents(res.data);
  }

  useEffect(() => {
    getStudentSpc();
  }, []);


  const rowEvents = {
      onClick: (e, row, rowIndex) => {
        window.location.href = `/students/${row._id}/edit`
      }
  };

  const columns = [
    {
      dataField: 'index',
      headerClasses: 'index',
      text: '#',
      sort: true
    }, {
      dataField: 'rankAbbrName',
      headerClasses: 'rank-abbr-name',
      text: 'ยศ',
      sort: true
    }, {
      dataField: 'fullName',
      headerClasses: 'full-name',
      text: 'ชื่อ-นามสกุล',
      filter: textFilter()
    }, {
      dataField: 'unit_no',
      headerClasses: 'org-abbr-name',
      text: 'นขต.ทอ.',
      formatter: cell => units[cell],
      filter: selectFilter({
        options: units
      })
    }, {
      dataField: 'spcNo',
      headerClasses: 'spc-name',
      text: 'สายวิทยาการ',
      formatter: cell => spcs[cell],
      filter: selectFilter({
        options: spcs
      })
    }, {
    //   dataField: 'unitSpcNo',
    //   headerClasses: 'unit-name',
    //   text: 'หน่วย หน. สายวิทยาการ',
    //   formatter: cell => unitSpcs[cell],
    // }, {
      dataField: 'age',
      headerClasses: 'age',
      text: 'อายุ',
      sort: true
    }, {
      dataField: 'seniorOfRank',
      headerClasses: 'senior-of-rank',
      text: 'ระยะเวลาการครองยศ',
      sort: true
    }, {
      dataField: 'ecl_score',
      headerClasses: 'ecl-score',
      text: 'คะแนนภาษาอังกฤษ',
      sort: true
    }
  ];
  

  return(
    <div className="table-list">
      {isLoading && students.length > 0 && <div className='container'>
        <BootstrapTable 
          striped 
          hover 
          bordered={ false } 
          keyField='id' 
          data={ students }
          columns={ columns } 
          filter={ filterFactory() }
          noDataIndication='-----ไม่พบข้อมูล-----'
          bootstrap4
          classes='student-course-table'
        />
      </div>}
    </div>
  )
}
